class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.dotsContainer = this.querySelector('.dots'); // Assumes there's a container for the dots.

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.dotsContainer) {
      this.dotsContainer.addEventListener('click', this.onDotClick.bind(this));
    }
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;

    // Create dots
    if (this.dotsContainer) {
      this.createDots();
    }

    this.update();
  }

  createDots() {
    this.dotsContainer.innerHTML = ''; // Clear existing dots
    for (let i = 0; i < this.totalPages; i++) {
      const dot = document.createElement('button');
      dot.classList.add('dot');
      dot.setAttribute('data-page', i + 1);
      this.dotsContainer.appendChild(dot);
    }
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    // Update buttons' disabled states
    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Update page count
    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    // Highlight the active dot    
    if (this.dotsContainer) {
      this.updateActiveDot();
    }
  }

  updateActiveDot() {
    const dots = this.dotsContainer.querySelectorAll('.dot');
    dots.forEach(dot => dot.classList.remove('active')); // Remove active class from all dots
    const activeDot = dots[this.currentPage - 1];
    if (activeDot) activeDot.classList.add('active');
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  onDotClick(event) {
    const dot = event.target;
    if (dot.classList.contains('dot')) {
      const page = parseInt(dot.getAttribute('data-page'));
      this.scrollToPage(page);
    }
  }

  scrollToPage(page) {
    if (page < 1 || page > this.totalPages) return;
    const slideScrollPosition = (page - 1) * this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);